import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { ICredentialsContext, CredentialsContext } from '../../../../../credentialsState/credentialsContext';
import { IItemCredentials } from 'types';
import DataController from 'components/DataController/DataController';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemCredentials;
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForDeletion, changeTypeOfModalWindow } = useContext<ICredentialsContext>(CredentialsContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const containerClasses = classNames(style.container, {
		[style.openInfo]: isOpenInfo,
	});
	const nameRowClasses = classNames(style.name, style.row);
	const apiKeyRowClasses = classNames(style.apiKey, style.row);
	const apiSecretRowClasses = classNames(style.apiSecret, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
		changeTypeOfModalWindow('toConfirmDeleteItem');
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={nameRowClasses} translationKey={data.name} withTooltip={true} data-test="name" />
				<Text
					className={apiKeyRowClasses}
					translationKey={data.credentials.apiKey}
					withTooltip={true}
					data-test="apiKey"
				/>
				<Text
					className={apiSecretRowClasses}
					translationKey={data.credentials.apiSecret}
					withTooltip={true}
					data-test="apiSecret"
				/>
				<div className={actionRowClasses}>
					<DataController
						onClickDelete={handleSetIdForDeletion}
						URLWithIDToEdit={`/credentials/edit?credentialID=${data.id}`}
						size="smallBtn"
					/>
				</div>
			</div>
		</div>
	);
};
